<template>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">  
          <div class="form-group">  
            <label for="name">{{ _('Name') }}</label> 
            <input class="form-control" type="text" id="pricerowName" ref="name" v-model="pricerow.name" :placeholder="_('Enter a name for the price row')" /> 
          </div>
        </div>
        <div class="col-md-6" id="pricerowUnitContainer" v-if="!isTransportation">
          <div class="form-group">  
            <label for="unit">{{ _('Unit') }}</label> 
            <div class="input-group">
              <input type="text" class="form-control" v-model="pricerow.unit" id="pricerowUnit" />
              <div class="input-group-btn">
                <Dropdown buttonClass="btn-default" direction="down" menuClass="dropdown-menu-right">
                  <template #trigger>
                    {{ ptUnitType }} <span class="caret"></span>
                  </template>
                  <li><a href="javascript:;" v-on:click="pricerow.unittype = '3'">{{ _('day(s)') }}</a></li>
                  <li><a href="javascript:;" v-on:click="pricerow.unittype = '2'">{{ _('hour(s)') }}</a></li>
                  <li><a href="javascript:;" v-on:click="pricerow.unittype = '1'">{{ _('minute(s)') }}</a></li>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" id="pricerowRateplanContainer" v-if="rateplans && rateplans.length">
        <div class="col-md-6">
          <pricerow-rateplan :pricerow="pricerow" :rateplans="rateplans" v-on:data="conditionChanged" />
        </div>
      </div>
      <div class="row" id="normalPricingContainer" v-if="isNormalPricing">
        <div class="col-md-6">
          <div class="form-group">
            <label for="price">{{ _('Base price (inc. vat)') }}</label>
            <div class="input-group">
              <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" id="pricerowPrice" :value="price" @input="validatePrice($event.target.value)" :placeholder="_('Enter base price')" />
              <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6" id="returnPriceContainer" v-if="isTransportation">
          <div class="form-group">
            <label for="price">{{ _('Roundtrip price (inc. vat)') }}</label>
            <div class="input-group">
              <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" id="pricerowReturnPrice" :value="returnPrice"  @input="validateReturnPrice($event.target.value)" :placeholder="_('Enter roundtrip price')" />
              <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group" id="basePriceIncludesContainer">
            <label for="price">{{ _('Base price includes') }}</label>
            <div class="input-group">
              <input type="text" class="form-control" id="pricerowIncludes" v-model="pricerow.includes" :disabled="!isIncludesEnabled" placeholder="" />
              <div class="input-group-addon">{{ _('participants') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" id="ticketPricingContainer" v-if="isTicketPricing">
        <div class="col-md-6">
          <div class="form-group">
            <label for="pricerowPricingSelector">{{ _('Pricing') }}</label>
            <select class="form-control" id="pricerowPricingSelector" v-model="pricerow.pricing_id">
              <option value="0" v-if="pricingOptions.length">{{ _('Select pricing') }}</option>
              <option value="0" v-else>{{ _('No pricing models available') }}</option>
              <option v-for="pricingOption in pricingOptions" :value="pricingOption.id">{{ pricingOption.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div id="pricetierContainer">
        <div class="row">
          <div :class="'col-md-' + ptColWidth" v-for="pricetier in product.sharedPricetier">
            <div class="form-group">
              <label for="pt">{{ pricetier.name }}{{ ptExtra }}</label>
              <div class="input-group">
                <input :value="pt && pt[pricetier.id] ? pt[pricetier.id].go : ''" @input="setPricetier(pricetier.id, $event.target.value)" type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control pricetierInput" />
                <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
                <input :value="pt && pt[pricetier.id] ? pt[pricetier.id].return : ''" @input="setPricetierReturn(pricetier.id, $event.target.value)" v-if="isTransportation" type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" />
                <div v-if="isTransportation" class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12" style="border-bottom: 1px #dddddd solid; margin-bottom: 10px">
          <label for="validity">{{ _('Valid') }}: <span v-if="hasConditions">{{ _('when the following conditions are met') }}</span><span v-else>{{ _('always') }}</span></label>
        </div>
      </div>
      <div id="conditionsContainer">
        <pricerow-condition v-for="(condition, index) in conditions" :key="index" :pricerow="pricerow" :routes="routes" :zones="zones" :conditions="conditions" :condition="condition" v-on:data="conditionChanged" v-on:add="conditionAdded" v-on:remove="conditionRemoved" />
      </div>
      <div class="conditionRow conditionSelectorRow" v-if="!newCondition">
        <label style="color: #999999" class="conditionLabel ifLabel">{{ _('if') }}</label>
        <div class="conditionContent">
          <button class="btn btn-success" v-on:click="addCondition" type="button"><i class="fa fa-fw fa-plus"></i> {{ _('Add Condition') }}</button>
          <pre v-if="false">{{ pricerow }}</pre>
        </div>
      </div>  
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="save" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
      <button type="button" class="btn btn-danger pull-left" v-on:click="remove"><i class="fa fa-trash fa-fw"></i>{{ _('Delete') }}</button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import constants from '~/lib/constants'
import currencies from '~/lib/currencies'
import formats from '~/lib/formats'
import { isPricerowTimerangeValid } from '~/lib/pricerowTimeRange'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      pricerow: {},
      newCondition: false,
      newConditions: [],
      persistConditions: []
    }
  },
  props: ['product', 'origPricerow', 'settings', 'routes', 'zones', 'pricingOptions', 'rateplans'],
  mixins: [constants, currencies, formats],
  computed: {
    ...mapGetters(['numberFormat']),
    isTransportation () {
      if (!this.product) {
        return false
      }
      const t = this.product.type + '-' + this.product.subtype + '-' + this.product.displayedtype
      return t === '1-3-generic'
    },
    isIncludesEnabled () {
      return this.product && parseInt(this.product.enable_participant_pricing)
    },
    isValid () {
      if (this.pricerow) {
        if (this.hasInvalidConditions) {
          return false
        }
        if (!this.isTransportation && (!parseInt(this.pricerow.unit) || parseInt(this.pricerow.unit) < 0)) {
          return false
        }
        if ((this.pricerow.price || parseInt(this.pricerow.pricing_id)) && this.pricerow.name) {
          return true
        }
      }
      return false
    },
    isTicketPricing () {
      if (!this.product) {
        return false
      }
      return parseInt(this.product.hide_pricing) === this.PRICING_TICKET
    },
    isNormalPricing () {
      return !this.isTicketPricing
    },
    hasConditions () {
      return this.conditions && this.conditions.length > 0
    },
    isTimerangeConditionActive () {
      return this.conditions.includes('timerange') || this.persistConditions.includes('timerange')
    },
    isTimerangeInvalid () {
      if (!this.isTimerangeConditionActive) {
        return false
      }
      return !isPricerowTimerangeValid(this.pricerow.timestart, this.pricerow.timeend)
    },
    hasInvalidConditions () {
      if (this.isTimerangeInvalid) {
        return true
      }
      if (this.hasConditions && this.conditions.includes('daterange')) {
        const validFormats = ['d.M.yyyy', 'dd.MM.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']
        const isDateValid = (dateStr) => {
          return dateStr && validFormats.some(format => DateTime.fromFormat(dateStr, format).isValid)
        }
        if (!isDateValid(this.pricerow.datestart) || !isDateValid(this.pricerow.dateend)) {
          return true
        }
      }
      return false
    },
    conditions () {
      let conditions = []
      if (this.pricerow) {
        if (parseInt(this.pricerow.min) || this.persistConditions.includes('min')) {
          conditions.push('min')
        }
        if (parseInt(this.pricerow.max) || this.persistConditions.includes('max')) {
          conditions.push('max')
        }
        if (parseInt(this.pricerow.minparticipants) || this.persistConditions.includes('minparticipants')) {
          conditions.push('minparticipants')
        }
        if (parseInt(this.pricerow.maxparticipants) || this.persistConditions.includes('maxparticipants')) {
          conditions.push('maxparticipants')
        }
        if (parseInt(this.pricerow.minresources) || this.persistConditions.includes('minresources')) {
          conditions.push('minresources')
        }
        if (parseInt(this.pricerow.maxresources) || this.persistConditions.includes('maxresources')) {
          conditions.push('maxresources')
        }
        if (this.pricerow.datestart || this.pricerow.dateend || this.persistConditions.includes('daterange')) {
          conditions.push('daterange')
        }
        if (parseInt(this.pricerow.timestart) || parseInt(this.pricerow.timeend) || this.persistConditions.includes('timerange')) {
          conditions.push('timerange')
        }
        if (this.pricerow.weekdays !== '1,2,3,4,5,6,7' || this.persistConditions.includes('weekday')) {
          conditions.push('weekday')
        }
        if (this.pricerow.startweekdays !== '1,2,3,4,5,6,7' || this.persistConditions.includes('startweekday')) {
          conditions.push('startweekday')
        }
        if (this.pricerow.endweekdays !== '1,2,3,4,5,6,7' || this.persistConditions.includes('endweekdays')) {
          conditions.push('endweekday')
        }
        if (parseInt(this.pricerow.route) || this.persistConditions.includes('route')) {
          conditions.push('route')
        }
        if (parseInt(this.pricerow.origin) || this.persistConditions.includes('origin')) {
          conditions.push('origin')
        }
        if (parseInt(this.pricerow.destination) || this.persistConditions.includes('destination')) {
          conditions.push('destination')
        }
        // Here we force newly added conditions to be last
        if (this.newConditions.length) {
          conditions = conditions.filter(c => !this.newConditions.includes(c))
        }
        for (let i = 0; i < this.newConditions.length; i++) {
          conditions.push(this.newConditions[i])
        }
        if (this.newCondition) {
          conditions.push('')
        }
      }
      return conditions
    },
    price () {
      if (!this.pricerow || !this.pricerow.price) {
        return ''
      }
      if (true || this.numberFormat === 'en-US') {
        return this.pricerow.price
      }
      return this.pricerow.price.replaceAll('.', ',')
    },
    returnPrice () {
      if (!this.pricerow || !this.pricerow.returnprice) {
        return ''
      }
      if (true || this.numberFormat === 'en-US') {
        return this.pricerow.returnprice
      }
      return this.pricerow.returnprice.replaceAll('.', ',')
    },
    pt () {
      let pt = {}
      if (!this.pricerow || !this.pricerow.pricetiers) {
        return pt
      }
      let pricetiers = this.pricerow.pricetiers.split(';')
      for (let i = 0; i < pricetiers.length; i++) {
        let data = pricetiers[i].split(':')
        if (!data[1]) {
          data[1] = ''
        }
        let gr = data[1].split(/\//)
        /*if (this.numberFormat !== 'en-US') {
          if (gr[0]) {
            gr[0] = gr[0].replaceAll('.', ',')
          }
          if (gr[1]) {
            gr[1] = gr[1].replaceAll('.', ',')
          }
        }*/
        pt[data[0]] = { 
          go: gr[0],
          return: gr[1]
        }
      }
      return pt
    },
    ptUnitType () {
      const _ = this._
      if (!this.pricerow || !this.pricerow.unittype) {
        return _('day(s)')
      }
      switch (parseInt(this.pricerow.unittype)) {
        case this.UNIT_MINUTE:
          return _('minute(s)')
        case this.UNIT_HOUR:
          return _('hour(s)')
        case this.UNIT_DAY:
        default:
          return _('day(s)')
      }
    },
    ptColWidth () {
      if (this.isTransportation) {
        return 6
      }
      return 3
    },
    ptExtra () {
      if (!this.isTransportation) {
        return ''
      }
      return '(' + this._('one way') + ' / ' + this._('round trip') + ')'
    }
  },
  components: {
    PricerowCondition: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowCondition.vue')),
    PricerowRateplan: defineAsyncComponent(() => import('~/components/modals/pricerow/PricerowRateplan.vue'))
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      if (!this.isValid) {
        return
      }
      this.$emit('save', this.pricerow)
    },
    remove () {
      this.$emit('remove', this.pricerow)
    },
    addCondition () {
      this.newCondition = true
    },
    conditionAdded (data) {
      this.newCondition = false
      this.newConditions.push(data)
      this.persistConditions.push(data)
    },
    conditionRemoved (data) {
      this.newConditions = this.newConditions.filter(c => !data)
      this.persistConditions = this.persistConditions.filter(c => c !== data)
      switch (data) {
        case 'min':
        case 'max':
        case 'minparticipants':
        case 'maxparticipants':
        case 'minresources':
        case 'maxresources':
          this.pricerow[data] = 0
          break
        case 'daterange':
          this.pricerow.datestart = 0
          this.pricerow.dateend = 0
          break
        case 'timerange':
          this.pricerow.timestart = 0
          this.pricerow.timeend = 0
          break
        case 'weekday':
        case 'startweekday':
        case 'endweekday':
          this.pricerow[data + 's'] = '1,2,3,4,5,6,7'
          break
        case 'route':
        case 'origin':
        case 'destination':
          this.pricerow[data] = ''
          break
      }
      if (!data) {
        this.newCondition = false
      }
    },
    conditionChanged (data) {
      Object.assign(this.pricerow, data)
    },
    validatePrice (val) {
      if (val) {
        this.pricerow.price = val
      } else {
        this.pricerow.price = ''
      }
    },
    validateReturnPrice (val) {
      if (val) {
        this.pricerow.returnprice = val
      } else {
        this.pricerow.returnprice = ''
      }
    },
    setPricetier (id, value) {
      let pt = this.pt
      let ptArr = []
      if (pt) {
        if (!pt[id]) {
          pt[id] = {}
        }
        pt[id].go = value
        for (var i in pt) {
          if (Object.prototype.hasOwnProperty.call(pt, i)) {
            let val = pt[i].go
            if (this.isTransportation) {
              val += '/' + pt[i].return
            }
            ptArr.push(i + ':' + val)
          }
        }
      }
      this.pricerow.pricetiers = ptArr.join(';')
    },
    setPricetierReturn (id, value) {
      let pt = this.pt
      let ptArr = []
      if (pt) {
        if (!pt[id]) {
          pt[id] = {}
        }
        pt[id].return = value
        for (var i in pt) {
          if (Object.prototype.hasOwnProperty.call(pt, i)) {
            let val = pt[i].go
            if (this.isTransportation) {
              val += '/' + pt[i].return
            }
            ptArr.push(i + ':' + val)
          }
        }
      }
      this.pricerow.pricetiers = ptArr.join(';')
    }
  },
  created () {
    this.pricerow = Object.assign({}, this.origPricerow)
  },
  mounted () {
    if (this.$refs.name) {
      this.$refs.name.focus()
    }
    this.persistConditions = this.conditions
  }
}
</script>
